import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import type { SessionKind } from "../api/types";

/**
 * Restricts a subtree to one session kind ("partner" or "staff"). Used
 * under RequireAuth, so by the time this runs we already have a session
 * and the password change has already been handled; the `status ===
 * "loading"` check below is defence in depth for that assumption (it
 * renders nothing rather than redirecting away while the very first
 * GET /session/me is still in flight).
 */
export function RequireRole({ role }: { role: Exclude<SessionKind, "anon"> }) {
  const { status, me } = useAuth();

  if (status === "loading") {
    return null;
  }

  if (!me || me.kind !== role) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
